<form [formGroup]="form">
  <div class="grid gap-4 xl:grid-cols-2">
    <app-form-control label="Imię">
      <input
        [formControl]="form.controls.firstName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Nazwisko">
      <input
        [formControl]="form.controls.lastName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Numer telefonu">
      <app-phone-number-with-prefix [formControl]="form.controls.phone" />
    </app-form-control>

    <app-form-control label="E-mail">
      <input
        [formControl]="form.controls.email"
        appPrimengInputText
        pInputText
        type="email" />
    </app-form-control>

    <app-form-control label="Kraj">
      <p-select
        [formControl]="form.controls.countryId"
        [options]="valueOrDefault(countrySelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true" />
    </app-form-control>

    @if (stateFormControlAvailability$ | async) {
      <app-form-control label="Region">
        <input
          [formControl]="form.controls.state"
          appPrimengInputText
          pInputText />
      </app-form-control>
    }

    <app-form-control label="Adres">
      <input
        [formControl]="form.controls.streetLine1"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Adres cd.">
      <input
        [formControl]="form.controls.streetLine2"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Kod pocztowy">
      <input
        [formControl]="form.controls.postCode"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Miasto">
      <input
        [formControl]="form.controls.city"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Nazwa firmy">
      <input
        [formControl]="form.controls.companyName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="NIP firmy">
      <input
        [formControl]="form.controls.companyNip"
        appPrimengInputText
        pInputText />
    </app-form-control>
  </div>

  <div class="flex justify-end gap-4">
    @if (pending()) {
      <app-spinner-filled />
    } @else {
      <p-button
        (onClick)="handleSubmitButtonClick()"
        [disabled]="form.invalid"
        appPrimengButton
        label="Zapisz"
        type="submit" />
    }
  </div>
</form>
